import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    const renderOption = (option, escape) => `<div><span class="breathwork-alternation-name">${escape(option.text)}</span><span class="breathwork-alternation-description">${escape(option.description || "")}</span></div>`
    this.select = new TomSelect(this.element, {
      allowEmptyOption: true,
      controlInput: null,
      searchField: [],
      render: { option: renderOption, item: renderOption }
    })
  }

  disconnect() {
    this.select?.destroy()
  }
}
